// Detects SQL injection patterns in a string.
// Targets sequences that enable injection, not individual keywords,
// to avoid false positives on legitimate input like "Drop off documents".
// Patterns cover all major SQL dialects: PostgreSQL, MySQL, SQLite, SQL Server, Oracle.
const SQL_PATTERNS = [
  /('|")\s*;/,                                            // quote + statement terminator
  /--/,                                                   // line comment
  /\/\*/,                                                 // block comment open
  /\*\//,                                                 // block comment close
  /\bUNION\s+SELECT\b/i,                                 // UNION-based injection
  /\bSELECT\s+.+\s+FROM\b/i,                            // SELECT ... FROM construct
  /\bDROP\s+TABLE\b/i,                                   // destructive DDL
  /\bDELETE\s+FROM\b/i,                                 // destructive DML
  /\bINSERT\s+INTO\b/i,                                 // DML injection
  /\bUPDATE\s+.+\s+SET\b/i,                             // DML injection
  /\bEXEC\s*\(/i,                                        // stored procedure execution
  /\bEXECUTE\s*\(/i,                                     // stored procedure execution
  /\bOR\s+['"]?\d+['"]?\s*=\s*['"]?\d+['"]?/i,          // OR 1=1 tautology
  /\bAND\s+['"]?\d+['"]?\s*=\s*['"]?\d+['"]?/i,         // AND 1=1 tautology
  /xp_\w+/i,                                             // SQL Server extended procedures
]

/**
 * Returns true if the value contains a SQL injection pattern.
 */
export function looksLikeSqlInjection(value) {
  if (typeof value !== 'string') return false
  return SQL_PATTERNS.some(pattern => pattern.test(value))
}
